import { useMerchantSummaryReport } from "../merchant_summary_report/useMerchantSummaryReport";
import { usePartnerCommissionSummary } from "../partner_commission_summary/usePartnerCommissionSummary";
import { usePaymentItemChannelReport } from "../payment_item_channel_report/usePaymentItemChannelReport";
import { usePaymentItemSummaryReport } from "../payment_item_summary_report/usePaymentItemSummaryReport";
import { useTransactionChannelSeparation } from "../transaction_channel_separation/useTransactionChannelSeparation";
import { useTransactionSummaryReport } from "../transaction_summary_report/useTransactionSummaryReport";
import { useIncidentTicketCategoryReport } from "../../components/pages/reports/incident_ticket_category_report/useIncidentTicketCategoryReport";
import { useIncidentTicketSeverityReport } from "../../components/pages/reports/incident_ticket_severity_report/useIncidentTicketSeverityReport";

export const reportHooks: Record<string, any> = {
  transaction_summary: useTransactionSummaryReport,
  partner_commission_summary: usePartnerCommissionSummary,
  merchant_summary: useMerchantSummaryReport,
  payment_item_summary: usePaymentItemSummaryReport,
  transaction_channel_separation: useTransactionChannelSeparation,
  payment_item_channel_report: usePaymentItemChannelReport,
  incident_ticket_category_report: useIncidentTicketCategoryReport,
  incident_ticket_severity_report: useIncidentTicketSeverityReport,

  // Add more report hooks here
};
